import { useState } from 'react';
import { Input } from '@iwoca/orion';
import { t } from '@lingui/core/macro';
import { Column } from '@tanstack/react-table';
import { TApplication } from 'lendingApi/applications.types';
import { FilterActionButtons } from '../FilterActionButtons/FilterActionButtons';
import { useTrackFilter } from '../useTrackFilter.hook';
import styles from './SearchColumnFilter.module.css';

type TProps = {
  column: Column<TApplication, unknown>;
  onClose: () => void;
};

export const SearchColumnFilter = ({ column, onClose }: TProps) => {
  const { trackFilterApplied, trackFilterReset } = useTrackFilter(
    column.columnDef.header,
  );
  const columnFilterValue = column.getFilterValue();
  const [localValue, setLocalValue] = useState<string>(
    typeof columnFilterValue === 'string' ? columnFilterValue : '',
  );

  const handleApply = () => {
    column.setFilterValue(localValue);
    trackFilterApplied(localValue);
    onClose();
  };

  const handleReset = () => {
    setLocalValue('');
    column.setFilterValue(undefined);
    trackFilterReset();
  };

  return (
    <div className={styles.filter}>
      <Input
        type="text"
        value={localValue}
        onChange={(e) => {
          setLocalValue(e.target.value);
        }}
        placeholder={t`Enter name`}
      />
      <FilterActionButtons
        onResetClick={handleReset}
        onApplyClick={handleApply}
      />
    </div>
  );
};
